// Note: These constants use camelCase instead of UPPER_SNAKE_CASE to maintain
// compatibility with existing imports in multiple files and to comply with
// the project's linter configuration, which enforces camelCase/PascalCase/snake_case.
// TODO: Consider refactoring to use UPPER_SNAKE_CASE (e.g., SCALE_INCREMENT)
// as per Simo's suggestion, which will require updating all imports and
// modifying the linter configuration to allow UPPER_SNAKE_CASE for constants.
export const scaleIncrement = 0.05 // 5% increment
export const minScale = 0.1
export const maxScale = 3.0

export const transformTransition = 'transform 0.05s ease-out'
